import { Field, Form, Formik } from 'formik';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import { TextArea } from '../../shared/controls/form';
import { Checkbox } from 'rsuite';

const Roles = ({ details }) => {
  let title = details?.title;
  let description = details?.description;
  const location = useLocation();

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const newOptions = [
    { id: '1', name: 'Administrator' },
    { id: '2', name: 'Standard' },
  ];

  const [currentStep, setCurrentStep] = useState(1);

  const handlePopupToggle = () => {
    setIsPopupOpen((prev) => !prev);
  };

  const [selectedRole, setSelectedRole] = useState('');

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
    setCurrentStep(1);
  };

  return (
    <>
      <div className="ViewLeadPageOuter">
        <div className="viewHeader">
          <h1>Settings</h1>
        </div>
        <div className="viewFormContainer">
          <div className="leftBlock">
            <ul>
              <li>
                <Link to="/settings">Personal Settings</Link>
              </li>
              <li>
                <Link to="/settings/users">
                  User - <span className="soon">Coming Soon...</span>
                </Link>
              </li>
              <li>
                <Link to="/settings/profiles">
                  Profile - <span className="soon">Coming Soon...</span>
                </Link>
              </li>
              <li className={location.pathname === '/settings/roles' ? 'activeList' : ''}>
                <Link to="/settings/roles">
                  Roles - <span className="soon">Coming Soon...</span>
                </Link>
              </li>
              <li>
                <Link to="/settings/templates">Templates</Link>
              </li>
            </ul>
          </div>
          <div className="rightBlock">
            <div className="whiteBlock">
              <div className="rightheader">
                <div className="flexDivhd">
                  <div>
                    <h2 className="pb-0">Roles</h2>
                  </div>
                  <div className="crmhead_vw">
                    <button className="btn btn-primary" onClick={handlePopupToggle}>
                      {' '}
                      New Role
                    </button>
                  </div>
                </div>
              </div>
              <div className="rightContent" id="rolenewuser_popup">
                {isPopupOpen && (
                  <div className="popup-overlay">
                    <div className="popup">
                      {/* Header Section */}
                      <div className="popup-header">
                        <h2>
                          {currentStep === 1 ? (
                            'Roles'
                          ) : (
                            <>
                              <Link href="#" className="rolelist">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  className="rolelist-icon"
                                  viewBox="0 0 16 16"
                                  style={{ marginRight: '8px' }}
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M15 8a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 7.5H14.5a.5.5 0 0 1 .5.5z"
                                  />
                                </svg>
                                Role List
                              </Link>
                            </>
                          )}
                        </h2>
                        <button
                          className="custom-btn-close"
                          onClick={() => setIsPopupOpen(false)}
                        ></button>
                      </div>

                      {/* Body Section */}
                      <div className="popup-body">
                        {currentStep === 1 && (
                          <Formik>
                            <Form>
                              <div className="row">
                                <div className="col-12 col-md-12">
                                  <div className="rolepopup-txt">
                                    <h2>New Role</h2>
                                    <p>
                                      This page will allow you to create a new role based on your
                                      organizational hierarchy. Create a new role and associate it
                                      with a higher role.
                                    </p>
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="input-container">
                                    <label htmlFor="rolename">
                                      Role Name
                                      <span className="required-star">*</span>
                                    </label>
                                    <Field
                                      onClick={() => setCurrentStep(2)}
                                      className="formik-input"
                                      required
                                      type="text"
                                      name="rolename"
                                      id="rolename"
                                    />
                                  </div>
                                </div>

                                <div className="col-12 col-md-6" id="selectreport">
                                  <div className="input-container">
                                    <label htmlFor="timeZoneId">Reports To</label>
                                    <Select
                                      name={'reportsto'}
                                      placeholder={'Select'}
                                      isRequired={false}
                                      options={newOptions}
                                      optionKeys={['id', 'name']}
                                      nameFormatter={true}
                                      styles={{
                                        control: (base, state) => ({
                                          ...base,
                                          borderRadius: '5px',
                                          borderColor: state.isFocused
                                            ? '#365397'
                                            : base.borderColor,
                                          boxShadow: state.isFocused
                                            ? '0 0 0 1px #365397'
                                            : base.boxShadow,
                                        }),
                                        menu: (base) => ({
                                          ...base,
                                          borderRadius: '5px',
                                          zIndex: 99999,
                                        }),
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                        option: (base, state) => ({
                                          ...base,
                                          backgroundColor: state.isSelected
                                            ? 'rgba(54, 83, 151, 0.3)'
                                            : state.isFocused
                                              ? '#365397'
                                              : base.backgroundColor,
                                          color: state.isSelected
                                            ? '#fff'
                                            : state.isFocused
                                              ? '#fff'
                                              : base.color,
                                          cursor: 'pointer',
                                        }),
                                      }}
                                      menuPortalTarget={document.body}
                                      components={{
                                        DropdownIndicator: (props) => (
                                          <div
                                            {...props.innerProps}
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                            }}
                                          >
                                            <svg
                                              width="18"
                                              height="20"
                                              viewBox="0 0 18 20"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M16.3334 18.25V16.4167C16.3334 15.4442 15.9471 14.5116 15.2595 13.8239C14.5718 13.1363 13.6392 12.75 12.6667 12.75H5.33341C4.36095 12.75 3.42832 13.1363 2.74069 13.8239C2.05306 14.5116 1.66675 15.4442 1.66675 16.4167V18.25M12.6667 5.41667C12.6667 7.44171 11.0251 9.08333 9.00008 9.08333C6.97504 9.08333 5.33341 7.44171 5.33341 5.41667C5.33341 3.39162 6.97504 1.75 9.00008 1.75C11.0251 1.75 12.6667 3.39162 12.6667 5.41667Z"
                                                stroke="#9B9B9B"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </div>
                                        ),
                                      }}
                                    />
                                  </div>
                                </div>

                                <div className="col-12 col-md-6">
                                  <div className="input-container">
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                      }}
                                    >
                                      <Checkbox />
                                      <label htmlFor="#" style={{ cursor: 'pointer' }}>
                                        Share Data with Peers
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-12 col-md-12">
                                  <div className="input-container">
                                    <TextArea
                                      label={'Description'}
                                      name={'description'}
                                      isRequired={false}
                                      placeholder={'Enter Description'}
                                    />
                                  </div>
                                </div>
                              </div>
                            </Form>
                          </Formik>
                        )}

                        {currentStep === 2 && (
                          <div className="crmrole_hd">
                            <p>Please select one role from the list.</p>

                            <div className="setting-role">
                              <ul className="tree">
                                <li>
                                  <details open>
                                    <summary>CEO</summary>
                                    <ul>
                                      <li>
                                        <details>
                                          <summary>
                                            Manager
                                            <div className="edit-delete-buttons">
                                              <svg
                                                width="14"
                                                height="14"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44771 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44771 11 8 11H11V8Z"
                                                  fill="#0F0F0F"
                                                />
                                                <path
                                                  fill-rule="evenodd"
                                                  clip-rule="evenodd"
                                                  d="M23 4C23 2.34315 21.6569 1 20 1H4C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4ZM21 4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4Z"
                                                  fill="#0F0F0F"
                                                />
                                              </svg>

                                              <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <g clip-path="url(#clip0_1739_5315)">
                                                  <path
                                                    d="M7.3335 2.66812H2.66683C2.31321 2.66812 1.97407 2.8086 1.72402 3.05864C1.47397 3.30869 1.3335 3.64783 1.3335 4.00145V13.3348C1.3335 13.6884 1.47397 14.0275 1.72402 14.2776C1.97407 14.5276 2.31321 14.6681 2.66683 14.6681H12.0002C12.3538 14.6681 12.6929 14.5276 12.943 14.2776C13.193 14.0275 13.3335 13.6884 13.3335 13.3348V8.66812M12.3335 1.66812C12.5987 1.4029 12.9584 1.25391 13.3335 1.25391C13.7086 1.25391 14.0683 1.4029 14.3335 1.66812C14.5987 1.93334 14.7477 2.29305 14.7477 2.66812C14.7477 3.04319 14.5987 3.4029 14.3335 3.66812L8.00016 10.0015L5.3335 10.6681L6.00016 8.00145L12.3335 1.66812Z"
                                                    stroke="#1E1E1E"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  />
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_1739_5315">
                                                    <rect width="16" height="16" fill="white" />
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </div>
                                          </summary>
                                        </details>
                                      </li>
                                    </ul>
                                  </details>
                                </li>
                              </ul>
                            </div>
                          </div>
                        )}
                        {/* Footer Section */}
                        {currentStep === 1 && (
                          <div className="popup-userfooter">
                            <button
                              type="button"
                              className="btn btn-outline-primary"
                              onClick={() => setIsPopupOpen(false)}
                            >
                              Cancel
                            </button>
                            <button type="submit" className="btn btn-primary">
                              Save
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="setting-role">
                  <div className="comingSoon">
                    <img src="../assets/images/soon.png" alt="Coming Soon" />
                    <h2>Coming Soon</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Roles;
